let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("baN47")).then(() => parcelRequire('3GUgg'));